<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 15:39:21
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-11 16:13:56
 * @FilePath: /chaoyongtuan/src/views/contentLibray/LocalMaterial/list/components/tableCells/rdTagGroupCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex flex-align-center">
		<rd-tag-group
			class="rd-tag-group"
			:list="row.tagList?.map(tag => tag.tagName)"
			:max="1"
			:row="{ ...row, tag_arr: row.tagList?.map(tag => ({ id: tag.tagId, tag_name: tag.tagName })) }"
			:canEdit="$auth.hasPermi('addTag:local-material')"
			:rowIsHover="row.visible"
		></rd-tag-group>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
	components: {},
	computed: {},
	props: {},

	mounted() {},

	methods: {},
};
</script>
<style lang="less" scoped></style>
